import type { Catalog } from "../../en";

/** Filipino: Widget Studio → Home tab (mirrors en/deploy-knowledge/widget-home.ts). */
export const widgetHome: Catalog["deployKnowledge"]["widgetStudio"]["home"] = {
  screen: {
    title: "Home screen",
    hint: "Naka-off: diretso sa chat bumubukas ang widget, tulad ngayon.",
    enable: "Ipakita ang Home",
    greeting: "Pagbati",
    greetingPlaceholder: "Kumusta! 👋",
    subtitle: "Subtitle",
    subtitlePlaceholder: "Narito kung paano kami makakatulong",
    showTo: "Ipakita ang Home sa",
    counter: "{{count}} sa {{max}}",
  },
  showTo: {
    everyone: "Lahat",
    new_visitors: "Mga bagong bisita",
    returning_visitors: "Mga bumabalik na bisita",
  },
  audience: {
    everyone: "Lahat ng nakakakita ng Home",
    new_visitors: "Mga bagong bisita",
    returning_visitors: "Mga bumabalik na bisita",
  },
  options: {
    title: "Mga opsyon",
    count: "({{count}} sa {{max}})",
    hint: "Gamitin ang mga arrow para ayusin ang pagkakasunod. Puwedeng magkaroon ng sariling audience ang bawat opsyon.",
    listLabel: "Mga opsyon ng Home",
    add: "Magdagdag ng opsyon",
    full: "Hanggang {{max}} opsyon lang. Mag-alis ng isa para makapagdagdag.",
    emptyTitle: "Wala pang opsyon",
    emptyBody: "Magdagdag ng hanggang {{max}} shortcut, tulad ng pag-book ng tour o pagtatanong tungkol sa tuition. Makikita ito ng mga bisita pagbukas ng widget.",
    editLabel: "I-edit",
    edit: "I-edit ang {{label}}",
    moveUp: "Itaas ang {{label}}",
    moveDown: "Ibaba ang {{label}}",
    remove: "Alisin ang {{label}}",
    moved: "Inilipat ang {{label}} sa posisyon {{position}} sa {{count}}",
    removed: "Inalis ang {{label}}",
    saved: "Na-save ang opsyon",
  },
  actions: {
    workflow: "Magsimula ng workflow",
    booking: "Booking",
    question: "Tanong",
    link: "Link",
    person: "Tao",
  },
  summary: {
    workflow: "Magsimula ng workflow · {{target}}",
    booking: "Buksan ang booking · {{target}}",
    question: "Magtanong · “{{target}}”",
    link: "Buksan ang link · {{target}}",
    person: "Kausapin ang isang tao",
    unavailable: "hindi na available",
  },
  dialog: {
    addTitle: "Magdagdag ng opsyon",
    editTitle: "Opsyon ng Home",
    intro: "Isang shortcut na nakikita ng mga bisita pagbukas ng widget.",
    icon: "Icon",
    iconHint: "Pumili ng icon para sa opsyong ito.",
    label: "Label",
    labelPlaceholder: "hal. Mag-book ng campus tour",
    descriptionLabel: "Paglalarawan",
    optional: "(opsyonal)",
    descriptionPlaceholder: "Mga requirement, deadline at hakbang",
    whenTapped: "Kapag pinindot",
    workflow: "Workflow",
    workflowPick: "Pumili ng workflow",
    workflowHint: "Mga live na workflow lang na may trigger na “Pumipili ang bisita ng Home option” ang nakalista.",
    workflowNone: "Wala pang live na workflow na gumagamit ng trigger na “Pumipili ang bisita ng Home option”.",
    workflowCreate: "Gumawa sa Workflows",
    workflowLoading: "Nilo-load ang mga workflow…",
    workflowLoadError: "Hindi ma-load ang mga workflow. Maaaring wala kang access.",
    unavailable: "Hindi available na workflow o action",
    booking: "Booking action",
    bookingPick: "Pumili ng booking action",
    bookingHint: "Binubuksan ang booking card ng agent na ito na may mga bukás na slot.",
    bookingNone: "Wala pang booking action ang agent na ito. Gumawa sa Actions.",
    bookingCreate: "Gumawa sa Actions",
    bookingLoading: "Nilo-load ang mga booking action…",
    bookingLoadError: "Hindi ma-load ang mga booking action. Maaaring wala kang access.",
    question: "Tanong",
    questionHint: "Ipinapadala bilang mensahe ng bisita. Sasagutin ito ng assistant mula sa iyong mga knowledge source.",
    link: "Link",
    linkHint: "Bubukas sa bagong tab. https:// na link lang ang gumagana.",
    personHint: "Magsisimula ng handoff sa isang tao, ayon sa iyong routing at oras ng opisina.",
    showTo: "Ipakita sa",
    cancel: "Kanselahin",
    save: "I-save ang opsyon",
  },
  errors: {
    labelRequired: "Maglagay ng label.",
    workflowRequired: "Pumili ng workflow.",
    bookingRequired: "Pumili ng booking action.",
    questionRequired: "Ilagay ang tanong.",
    urlInvalid: "Gumamit ng buong https:// na link.",
    tooLong: "Masyadong mahaba ito.",
    invalid: "Suriin ang field na ito.",
  },
  icons: {
    "message-circle": "Chat",
    "graduation-cap": "Graduation cap",
    wallet: "Wallet",
    calendar: "Kalendaryo",
    download: "I-download",
    headset: "Headset",
    "file-text": "Dokumento",
    info: "Impormasyon",
    phone: "Telepono",
    mail: "Email",
    "map-pin": "Lokasyon",
    star: "Bituin",
    "life-buoy": "Suporta",
    "book-open": "Aklat",
    megaphone: "Anunsyo",
    globe: "Website",
  },
  messenger: {
    title: "Messenger Get Started menu",
    hint: "Ipinapakita sa Messenger bago ang unang mensahe, at nananatili sa menu (☰) pagkatapos.",
    enable: "Messenger Get Started menu",
    greeting: "Text ng pagbati (ipinapakita bago ang “Get Started”)",
    greetingHint: "Hanggang {{max}} character. Ilalagay ng Facebook ang pangalan kung saan mo isinulat ang {{token}}.",
    menu: "Gamitin ang mga opsyon ng Home bilang menu",
    menuHint: "Ang unang {{count}} opsyon ang magiging menu item; ang mga “Buksan ang link” ay bubukas sa browser ng Messenger.",
    note: "Para sa Facebook Page na nakakonekta sa Channels. Maaaring abutin ng ilang minuto bago lumabas ang pagbabago sa Facebook.",
    channels: "Buksan ang Channels",
    syncPage: "Facebook Page: {{page}}",
    syncedAt: "Huling na-sync {{when}}",
    noPage: "Wala pang nakakonektang Facebook Page. Magkonekta ng isa sa Channels para magamit ang Get Started menu.",
    sync: {
      synced: "Naka-sync sa Facebook",
      removed: "Inalis sa Page",
      failed: "Hindi tinanggap ng Facebook ang update",
      skipped: "Hindi ipinadala sa Facebook",
      never: "Hindi pa naipapadala sa Facebook",
    },
  },
  preview: {
    live: "Preview ng Home",
    channel: "Channel ng preview",
    widget: "Widget",
    messenger: "Messenger",
    off: "Naka-off ang Home, kaya diretso sa chat bumubukas ang widget. I-on ito para ipakita ang screen na ito.",
    widgetFrame: "Preview ng Widget Home",
    messengerFrame: "Preview ng Messenger",
    defaultGreeting: "Kumusta! 👋",
    defaultSubtitle: "Narito kung paano kami makakatulong",
    optionsLabel: "Preview ng mga opsyon ng Home",
    noOptions: "Dito lalabas ang iyong mga opsyon.",
    questionTitle: "May iba pang tanong?",
    questionBody: "Sumasagot ang aming assistant mula sa iyong mga knowledge source.",
    ask: "Magtanong sa amin",
    poweredBy: "Pinapagana ng {{product}}",
    privacy: "Privacy",
    typicalReply: "Kadalasang sumasagot agad",
    getStarted: "Get Started",
    menu: "Menu",
    messengerEmpty: "I-on ang Get Started o ang menu para makita ang mga ito rito.",
    sampleName: "Ana",
    footer: "Gamit ng preview ang kulay ng brand at radius mula sa Itsura. Binibilang sa ibaba ang mga tap, view at conversion ng opsyon.",
  },
  stats: {
    title: "Resulta ng Home",
    window: "Nakaraang {{days}} araw",
    impressions: "Mga view ng Home",
    conversations: "Mga nasimulang usapan",
    taps: "Mga tap bawat opsyon",
    tapCount_one: "{{count}} tap",
    tapCount_other: "{{count}} tap",
    emptyTitle: "Wala pang view ang Home",
    emptyBody: "I-publish ang Home at magsisimulang magbilang kapag binuksan ng mga bisita ang widget.",
    errorTitle: "Hindi ma-load ang numero ng Home",
    errorBody: "Tingnan ang koneksyon at subukan ulit.",
    noTaps: "Wala pang tap",
    removedOption: "{{id}} (inalis)",
  },
};
